import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import debounce from 'lodash/debounce';
import TagSelect from '../TagSelect';
var tagShape = PropTypes.shape({
  id: PropTypes.string,
  value: PropTypes.string.isRequired
});
export var TagSuggest = /*#__PURE__*/function (_Component) {
  function TagSuggest() {
    var _this;
    _classCallCheck(this, TagSuggest);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TagSuggest, [].concat(args));
    _defineProperty(_this, "debouncedSuggestions", debounce(function (parentType, parentId, tagText) {
      return _this.props.getTagSuggestions(parentType, parentId, tagText);
    }, 200));
    _defineProperty(_this, "handleTagInputChange", function (tagText) {
      var _this$props = _this.props,
        parentType = _this$props.parentType,
        parentId = _this$props.parentId;
      _this.props.setTagInput(parentType, parentId, tagText);
      if (tagText != null) {
        _this.debouncedSuggestions(parentType, parentId, tagText);
      } else {
        _this.props.setTagSuggestions(parentType, parentId, null, tagText);
      }
    });
    return _this;
  }
  _inherits(TagSuggest, _Component);
  return _createClass(TagSuggest, [{
    key: "getTagSuggestions",
    value: function getTagSuggestions() {
      var _this$props2 = this.props,
        defaultSuggestions = _this$props2.defaultSuggestions,
        tagSuggestions = _this$props2.tagSuggestions,
        tags = _this$props2.tags;
      var suggestions = tagSuggestions || Immutable.fromJS(defaultSuggestions);
      var visibleTagIds = tags.map(function (tag) {
        return tag.id;
      });
      // Exclude suggestions for tags already selected
      return suggestions.filterNot(function (tag) {
        return visibleTagIds.includes(tag.get('id'));
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(TagSelect, {
        allowNewTags: this.props.allowNewTags,
        noMatchText: this.props.noMatchText,
        tags: this.props.tags,
        tagInput: this.props.tagInput,
        tagSuggestions: this.getTagSuggestions().toJS(),
        newTagSuggest: this.props.newTagSuggest,
        onChange: this.props.onChange,
        onInputChange: this.handleTagInputChange
      });
    }
  }]);
}(Component);
_defineProperty(TagSuggest, "propTypes", {
  allowNewTags: PropTypes.bool,
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.string.isRequired,
  noMatchText: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultSuggestions: PropTypes.arrayOf(tagShape),
  tagSuggestions: ImmutablePropTypes.listOf(ImmutablePropTypes.map),
  setTagInput: PropTypes.func.isRequired,
  newTagSuggest: PropTypes.string,
  getTagSuggestions: PropTypes.func.isRequired,
  setTagSuggestions: PropTypes.func.isRequired,
  tagInput: PropTypes.string,
  tags: PropTypes.arrayOf(tagShape)
});
_defineProperty(TagSuggest, "defaultProps", {
  allowNewTags: false,
  newTagSuggest: null,
  tagInput: null,
  tags: [],
  defaultSuggestions: [],
  tagSuggestions: null
});
export default TagSuggest;